// extracted by mini-css-extract-plugin
export var container = "_b1-0";
export var content = "_b1-3";
export var customerTitle = "_b1-4";
export var empty = "_b1-5";
export var gray = "_b1-6";
export var header = "_b1-7";
export var info = "_b1-8";
export var loading = "_b1-2";
export var loadingCard = "_b1-9";
export var oneLine = "_b1-a";
export var personName = "_b1-e";
export var pillContainer = "_b1-b";
export var selected = "_b1-1";
export var text = "_b1-c";
export var twoLines = "_b1-d";
export var unread = "_b1-f";
export var unreadIndicator = "_b1-g";